import { Input, inputChrome } from "."

// Ticket #4366 gives textareas the new border, radius and state chrome only — no fixed height and no floating label.
// The geometry below is the pre-existing one, kept verbatim; only the chrome is new. It no longer spreads
// `Input.variants.primary.field`, because that variant is now a fixed 48px box.
const field = {
  ...inputChrome,
  height: "auto",
  maxHeight: "52px",
  p: "16px",
}

export const Textarea = {
  baseStyle: {
    ...Input.baseStyle.field,
  },
  sizes: {
    default: {},
  },
  variants: {
    outline: field,
    giftCard: field,
    giftCardAlt: field,
  },
  defaultProps: {
    size: "default",
    variant: "outline",
  },
}
